const equipRoutes = [
    {
        path: '/equip',
        name: 'equip',
        component: () => import('../index')
    }
]
export default equipRoutes
